/**
 * ⚠️⚠️ UNA REGLA DE ENRUTADO «INCOMPLETA» PARA EL EDITOR SÍ ACTUABA EN EL MOTOR.
 *
 * Medido por la UI el 2026-08-16 en el importador personalizado del cliente:
 * basta pulsar «+ Añadir regla de enrutado» y no rellenar nada. La fila nace
 * con destino «Earn» preseleccionado y condición VACÍA, y el motor la evalúa
 * como `evaluateCondition('', 'equals', '')` → **cierto en todas las filas**:
 * las seis filas del fichero pasaron de submedio «Spot» a «Earn» sin que nadie
 * lo pidiera. Ese submedio se persiste en `bat.transactions.group` y agrupa los
 * balances.
 *
 * La causa es que «completa» estaba definida DOS veces, y ninguna miraba el
 * operador:
 *
 *     editor  (isTransferRuleComplete)  column && value && to
 *     motor   (selectRoutingOnlyTransferRules)  typeof column === 'string' && to
 *
 * Y discrepaban en las DOS direcciones:
 *   - sin columna → el editor no la cuenta y el motor reencamina TODO;
 *   - con `is_empty` / `is_not_empty` (que no llevan valor) → el motor la aplica
 *     bien y el editor jamás la da por completa, así que la insignia dice «0» y
 *     el botón de añadir otra regla se queda bloqueado.
 *
 * Esta es LA definición, y la leen los dos.
 */

/** Operadores que NO necesitan valor: la pregunta la hace el propio operador. */
const VALUELESS_OPERATORS = new Set(['is_empty', 'is_not_empty'])

export interface RoutingRuleShape {
  condition?: { column?: string | null; operator?: string | null; value?: string | null } | null
  to?: string | null
}

function isFilled(value: string | null | undefined): boolean {
  return typeof value === 'string' && value.trim() !== ''
}

/**
 * ¿Esta regla de enrutado puede actuar sobre una fila?
 *
 * Hace falta:
 *   - una COLUMNA: sin ella no hay celda que mirar, y `is_empty` sobre «ninguna
 *     columna» casaría con todas las filas;
 *   - un DESTINO, que es el efecto de la regla;
 *   - un VALOR, salvo con `is_empty` / `is_not_empty`.
 */
export function isRoutingRuleActionable(rule: RoutingRuleShape): boolean {
  const condition = rule.condition
  if (!condition) return false
  if (!isFilled(condition.column)) return false
  if (!isFilled(rule.to)) return false
  if (VALUELESS_OPERATORS.has((condition.operator ?? '').trim())) return true
  return isFilled(condition.value)
}
